<template>
  <div
    :class="!ativoComp ? 'ui-textarea inativo' : destaque ? 'ui-textarea destaque' : 'ui-textarea'"
    :style="`height: ${altura}`"
  >
    <label>{{ label }}</label>
    <textarea
      :style="`height: calc(${altura} - 10px)`"
      :class="destaque ? 'roxo' : ''"
      :placeholder="placeholder"
      autocomplete="new-password"
      :maxlength="tamanhoMax"
      type="text"
      v-model="valor"
    />
  </div>
</template>

<script>
export default {
  name: 'UiTextarea',

  props: {
    ativo: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'Placeholder',
    },
    tamanhoMax: {
      type: Number,
    },
    altura: {
      type: String,
      default: '40px',
    },
    destaque: {
      type: Boolean,
    },
  },

  data() {
    return {
      valor: undefined,
    };
  },

  computed: {
    ativoComp() {
      return this.ativo;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.ui-textarea {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  border-radius: 5px;
  border: 1px solid $cor_cinza_medium;
  height: 40px;
  width: 100%;

  & label {
    position: absolute;
    top: 0;
    left: 10px;
    transform: translate(0, -60%);
    font-size: 10px;
    padding: 0 5px;
    color: $cor_cinza_dark;
    background: white;
  }

  & textarea {
      font-family: 'VivoType';
    resize: none;
    background: transparent;
    color: $cor_cinza_dark;
    font-weight: bold;
    font-size: 15px;
    line-height: 20px;
    border-radius: 5px;
    padding: 10px 0 0 15px;
    width: 100%;
    outline: none;
    border: 0px;
    transition: all 0.2s ease-in-out;

    &:hover {
      box-shadow: inset 0px 0px 5px rgba(102, 0, 153, 0.25);
    }

    &:focus {
      color: $cor_roxo;
      border: 1px solid $cor_roxo;
      // box-shadow: inset 0px 0px 5px rgba(102, 0, 153, 0.25);
    }

    &::placeholder {
      color: $cor_cinza_medium;
      font-weight: 400;
    }
  }

  & .roxo {
    font-weight: bold;
    color: $cor_roxo;
  }
}

.inativo {
  border: 1px solid $cor_cinza_light;
  background: $cor_cinza_light;

  & span {
    cursor: default !important;
    color: $cor_cinza_medium !important;
  }

  &:hover {
    background: $cor_cinza_light !important;
  }
}

.destaque {
  border: 1px solid $cor_roxo;
  box-shadow: inset 0px 0px 10px rgba(102, 0, 153, 0.25);
}
</style>
